export default __webpack_public_path__ + "static/media/Vector-8.2a46e7a6.svg";